// components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  
  // Check if both token and user data exist
  if (!token || !user) {
    // Clear any partial data
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return <Navigate to="/" replace />;
  }
  
  // Validate token format (basic check)
  try {
    // If you're using JWT, you can decode and check expiry here
    // For now, just check if user data is valid JSON
    const userData = JSON.parse(user);
    
    // Additional validation: check if user object has required fields
    if (!userData.id || !userData.email) {
      console.error('Invalid user data structure');
      localStorage.clear();
      return <Navigate to="/" replace />;
    }
  } catch (error) {
    console.error('Invalid user data, logging out:', error);
    localStorage.clear();
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default ProtectedRoute;